import { MergedBase } from "../mfrm-choose-your-foundation";

export const getDisplayedBaseName = (base: MergedBase) => {
    const lowOrReg = base.Dimensions?.find(Dimension => Dimension.DimensionTypeValue === 1)?.DimensionValue?.Value;
    const profile = lowOrReg ? ` - ${lowOrReg} Profile - ${lowOrReg === 'Low' ? '5"' : '9"'}` : '';
    return `${base.brand} ${base.Name}${profile}`;
};
